import { NgModule, LOCALE_ID, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { LoggerModule, NgxLoggerLevel, NGXLogger, INGXLoggerConfig } from 'ngx-logger';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ENV } from '../config/env.config';
import { PipesModule } from './pipes/pipes.module';
import { HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from './components/components.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { InterceptorModule } from './interceptor/interceptor.module';
import { RoutingService } from './services/routing/routing.service';
import { AppInitService } from './services/app-init/app-init.service';
import { IonicStorageModule } from '@ionic/storage-angular';  
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';
import { DatabaseService } from './services/database/database.service';
import { RestAuthService } from './services/rest-auth/rest-auth.service';
import { UtilsService } from './services/utils/utils.service';
import { NavExtrasService } from './services/nav-extra/nav-extras.service';
import { AuthService } from './services/auth/auth.service';  
import { FirebaseMessaging } from '@awesome-cordova-plugins/firebase-messaging/ngx';
import { MessagingService } from './services/messaging/messaging.service';  
import { StorageService } from './services/storage/storage.service'; 
import { SwiperModule } from 'swiper/angular';

const loggerConfig: INGXLoggerConfig = {
 level: NgxLoggerLevel.DEBUG,
  serverLogLevel: NgxLoggerLevel.ERROR,
  disableConsoleLogging: environment.production,
  enableSourceMaps: true
};

export function initApp(appInitService: AppInitService) {
  return (): Promise<any> => appInitService.init();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    PipesModule,
    LoggerModule.forRoot(loggerConfig),  
    HttpClientModule,
    IonicModule.forRoot(),
    ComponentsModule,
    AngularFireModule.initializeApp(ENV.FIREBASE_CONFIG),
    AngularFireAuthModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule,
    InterceptorModule,
    IonicStorageModule.forRoot(),
    MatIconModule,
    MatCardModule,
    SwiperModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AppInitService],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'fr' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    RoutingService,
    AppInitService,
    NGXLogger,
    GooglePlus,
    DatabaseService,
    RestAuthService,
    UtilsService,
    NavExtrasService,
    AuthService,
    FirebaseMessaging,
    MessagingService,
    StorageService 
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    registerLocaleData(localeFr);
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg')); // path where mdi.svg is placed
  }
}
